module.exports = __webpack_public_path__ + "img/banner-1-tablet.4b9ef87.webp";